import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhTW from "antd/locale/zh_TW";

import { RoleProvider } from "./contexts/Role";
import App from "./App";
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhTW}
      theme={{
        cssVar: true,
        components: { Steps: { descriptionMaxWidth: 150 } },
      }}
    >
      <BrowserRouter>
        <RoleProvider>
          <App />
        </RoleProvider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
